<template>
<transition name="modal">
<div id="termsModal" class="termsModal">
  <div class="termsModal__close"><span @click="$emit('clickClose')">Close</span></div>
  <section class="termsModal__main">
    <h2 class="termsModal__main__headline">本サービスの承諾事項について</h2>
    <p class="termsModal__main__intro">本サービスでカスタマイズを行った商品を購入されるお客様は、必ず以下の承諾事項を読んだ上で、末尾にある「承諾する」にチェックを入れて、購入画面にお進み下さい。</p>
    <div class="termsModal__main__wrap">
      <ul class="termsModal__main__wrap__list">
        <li>カスタマイズされた商品の返品・交換・カスタマイズ内容の変更は受けておりません。ご了承ください。</li>
        <li>ご利用のパソコンや環境によって、商品・ワッペン・刺繍の色やサイズ、ワッペンや刺繍の取り付け位置が上下左右に若干ぶれるなど、実際の商品と異なって見える場合がございます。あらかじめご理解の上、お買い求めください。</li>
        <li>ご注文内容に基づいて加工を実施したにもかかわらず、仕上がりにご満足いただけない場合でも、商品代、加工料金のご返金はお受けしかねます。</li>
        <li>承ったカスタマイズが困難であることが発覚した場合、お客様に連絡のうえ、加工サービスの内容を変更、またはキャンセルさせていただく場合がございます。</li>
      </ul>
      <p class="termsModal__main__wrap__text">以上、すべての注意事項を承諾したうえでカスタマイズ加工サービスを申し込みます。</p>
      <div
        class="termsModal__main__check"
        :class="{ 'is-agree': isAgree }"
        @click="toggleAgree">上記事項に承諾する</div>
    </div>
    <div
      class="termsModal__main__btn"
      :class="{ 'is-agree': isAgree }"
      @click="checkAgree">この商品の購入画面へ進む
    </div>
    <div class="termsModal__main__back"><span @click="$emit('clickClose')">カスタマイズ商品の詳細画面へ戻る</span></div>
  </section>
</div>
</transition>
</template>

<script>
export default {
  data () {
    return {
      isAgree: false
    }
  },
  methods: {
    toggleAgree () {
      if (this.isAgree === false) {
        this.isAgree = true
        return false
      }
      if (this.isAgree === true) {
        this.isAgree = false
        return false
      }
    },
    checkAgree () {
      if (this.isAgree === false) return false
      if (this.isAgree === true) this.$emit('buyItem')
    }
  }
}
</script>

<style lang="scss" scoped>
.termsModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  transition: all .3s ease;
  background: rgba(#111, 0.9);
  color: $base-white;
  line-height: 1.5;
  overflow-y: scroll;
  &__close {
    text-align: right;
    padding: 15px;
    span {
      display: inline-block;
      padding: 15px 0;
    }
  }
  &__main {
    padding: 30px 15px 50px;
    &__headline {
      font-size: 18px;
      font-weight: bold;
    }
    &__intro {
      font-size: 14px;
      padding: 15px 0 30px;
    }
    &__wrap {
      font-size: 14px;
      padding: 15px;
      border: 1px solid $base-white;
      &__list {
        list-style: decimal;
        padding: 15px 0 15px 20px;
        li {
          margin-bottom: 25px;
        }
      }
    }
    &__check {
      padding: 15px 0 15px 30px;
      font-size: 20px;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 22px;
        height: 22px;
        background: url('../assets/images/preview/preview-check-gray.svg') top left no-repeat;
        background-size: 22px 22px;
        margin-top: -12px;
        transition: all 0.3s;
      }
      &.is-agree {
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          width: 22px;
          height: 22px;
          background: url('../assets/images/preview/preview-check-blue.svg') top left no-repeat;
          background-size: 22px 22px;
          margin-top: -12px;
          transition: all 0.3s;
        }
      }
    }
    &__btn {
      margin: 30px auto 20px;
      padding: 15px 0;
      text-align: center;
      width: calc(100% - 30px);
      background-color: $gray;
      transition: all 0.3s;
      cursor: pointer;
      &.is-agree {
        background-color: $blue;
        transition: all 0.3s;
      }
    }
    &__back {
      font-size: 14px;
      text-align: center;
      cursor: pointer;
      span {
        padding-bottom: 2px;
        border-bottom: 1px solid $base-white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TermsModal.vue